module.exports = __webpack_public_path__ + "static/media/1002267.0b13af6f.png";